import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import overlayTypes from 'helpers/enums/overlayTypes'

import { overlaySelectors } from 'redux/selectors'

import SchoolLibraryOnboardingOverlay from 'views/private_library/overlays/school_library_onboarding_overlay'
import DistrictLibraryOnboardingOverlay from 'views/private_library/overlays/district_library_onboarding_overlay'
import OnboardingCreateLessonOverlay from 'views/my_library/overlays/onboarding_create_lesson_overlay'
import MyLibrarySubsOverlay from 'views/my_library/overlays/subs_overlay'
import DoubleStorageOverlay from 'views/dm_storage_experiment/DMStorageExperiment'
import AdminOnboardingNoStoreDownloads from 'views/admin_onboarding/no_store_downloads/NoStoreDownloads'
import AdminOnboardingAddTeachers from 'views/admin_onboarding/add_teachers/AddTeachers'
import AdminOnboardingNoDMInformation from 'views/admin_onboarding/no_dm_information/NoDMInformation'
import SchoolUserOnboardingOverlay from 'views/my_library/overlays/school_free_trial_onboarding/user/school_free_trial_onboarding_overlay'
import SchoolTrialOnboardingOverlay from 'views/my_library/overlays/school_free_trial_onboarding/admin/school_free_trial_onboarding_overlay'
import PremiumActivitiesNotification from 'views/admin_onboarding/premium_activities_notification/PremiumActivitiesNotification'
import FirstLessonOverlay from 'containers/first_lesson/container'
import TimeToClimbOverlay from 'views/my_library/overlays/time_to_climb/time_to_climb_overlay'
import BindersWelcomeOverlay from 'views/binders/welcome/binders_welcome_overlay'
import FlocabularyAnnouncementOverlay from 'views/my_library/overlays/flocabulary_announcement/flocabulary_announcement_overlay'
import GoogleSlidesTransitionOverlay from 'views/my_library/overlays/google_slides_transition/google_slides_transition_overlay'
import FlocabularyRestrictionWarningOverlay from 'views/slides/content/flocabulary/creation_tool/overlays/flocabulary_warning_overlay/flocabulary_warning_overlay'
import FlocabularyLimitReachedOverlay from 'views/slides/content/flocabulary/creation_tool/overlays/flocabulary_limit_reached_overlay/flocabulary_limit_reached_overlay'
import ImmersiveReaderOverlay from 'views/my_library/overlays/immersive_reader/immersive_reader_overlay'
import NickelTourOverlay from 'containers/my_library/overlays/nickel_tour/container'
import IVideoUploadingOverlayContainer from 'containers/creation_tool/interactive_video/create/overlays/uploading_overlay/container'

const OVERLAY_COMPONENTS = {
	[overlayTypes.FEATURE_SL_ONBOARDING_OVERLAY_ID]: SchoolLibraryOnboardingOverlay,
	[overlayTypes.FEATURE_DL_ONBOARDING_OVERLAY_ID]: DistrictLibraryOnboardingOverlay,
	[overlayTypes.FEATURE_OB_LESS_CREATE_OVERLAY_ID]: OnboardingCreateLessonOverlay,
	[overlayTypes.FEATURE_SUBS_OVERLAY_ID]: MyLibrarySubsOverlay,
	[overlayTypes.FEATURE_DOUBLE_STORAGE_OVERLAY_ID]: DoubleStorageOverlay,
	[overlayTypes.FEATURE_ADMIN_ONBOARDING_NO_DOWNLOADS_OVERLAY_ID]: AdminOnboardingNoStoreDownloads,
	[overlayTypes.FEATURE_ADMIN_ONBOARDING_ADD_TEACHERS_OVERLAY_ID]: AdminOnboardingAddTeachers,
	[overlayTypes.FEATURE_ADMIN_ONBOARDING_NO_DM_OVERLAY_ID]: AdminOnboardingNoDMInformation,
	[overlayTypes.FEATURE_SCHOOL_USER_ONBOARDING_OVERLAY_ID]: SchoolUserOnboardingOverlay,
	[overlayTypes.FEATURE_SCHOOL_TRIAL_ONBOARDING_OVERLAY_ID]: SchoolTrialOnboardingOverlay,
	[overlayTypes.FEATURE_ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_OVERLAY_ID]: PremiumActivitiesNotification,
	[overlayTypes.FEATURE_FIRST_LESSON_OVERLAY_ID]: FirstLessonOverlay,
	[overlayTypes.FEATURE_TIME_TO_CLIMB_OVERLAY_ID]: TimeToClimbOverlay,
	[overlayTypes.FEATURE_GOOGLE_SLIDES_TRANSITION_OVERLAY]: GoogleSlidesTransitionOverlay,
	[overlayTypes.FEATURE_BINDERS_WELCOME_OVERLAY_ID]: BindersWelcomeOverlay,
	[overlayTypes.FEATURE_FLOCABULARY_ANNOUNCEMENT_OVERLAY_ID]: FlocabularyAnnouncementOverlay,
	[overlayTypes.FEATURE_FLOCABULARY_RESTRICTION_WARNING_ID]: FlocabularyRestrictionWarningOverlay,
	[overlayTypes.FEATURE_FLOCABULARY_LIMIT_REACHED_OVERLAY_ID]: FlocabularyLimitReachedOverlay,
	[overlayTypes.FEATURE_IMMERSIVE_READER_OVERLAY_ID]: ImmersiveReaderOverlay,
	[overlayTypes.FEATURE_NICKEL_TOUR_OVERLAY_ID]: NickelTourOverlay,
	[overlayTypes.FEATURE_INTERACTIVE_VIDEO_UPLOADING_OVERLAY]: IVideoUploadingOverlayContainer,
}

const OverlaysController = props => {
	if (!props.overlayType || !OVERLAY_COMPONENTS[props.overlayType]) {
		return null
	}

	const SpecificModal = OVERLAY_COMPONENTS[props.overlayType]
	return <SpecificModal />
}


function mapStateToProps(state) {
	return overlaySelectors.overlayNotificationMessageSelector(state)
}

OverlaysController.propTypes = {
	overlayType: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
}

export default connect(mapStateToProps, null)(OverlaysController)
